import { datavizSeries } from '~/layout/dataviz'

// Tableau 20
// https://github.com/nagix/chartjs-plugin-colorschemes/blob/d96a01846626881aa4bec56828c333af81050906/src/colorschemes/colorschemes.tableau.js#L7
const tableau20 = [
  '#4E79A7',
  '#A0CBE8',
  '#F28E2B',
  '#FFBE7D',
  '#59A14F',
  '#8CD17D',
  '#B6992D',
  '#F1CE63',
  '#499894',
  '#86BCB6',
  '#E15759',
  '#FF9D9A',
  '#79706E',
  '#BAB0AC',
  '#D37295',
  '#FABFD2',
  '#B07AA1',
  '#D4A6C8',
  '#9D7660',
  '#D7B5A6',
]

const colors = [
  '#4E79A7',
  '#F28E2B',
  '#E15759',
  '#76B7B2',
  '#59A14F',
  '#EDC948',
  '#B07AA1',
  '#FF9DA7',
  '#9C755F',
  '#BAB0AC',
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F7F7F',
  '#BCBD22',
  '#17BECF',
  '#393B79',
  '#5254A3',
  '#6B6ECF',
  '#9C9EDE',
  '#637939',
  '#8CA252',
  '#B5CF6B',
  '#CEDB9C',
  '#8C6D31',
  '#BD9E39',
  '#E7BA52',
  '#E7CB94',
  '#843C39',
  '#AD494A',
  '#D6616B',
  '#E7969C',
  '#7B4173',
  '#A55194',
  '#CE6DBD',
  '#DE9ED6',
  '#3182BD',
  '#6BAED6',
  '#9ECAE1',
  '#C6DBEF',
  '#E6550D',
  '#FD8D3C',
  '#FDAE6B',
  '#FDD0A2',
  '#31A354',
  '#74C476',
  '#A1D99B',
  '#C7E9C0',
  '#756BB1',
  '#9E9AC8',
  '#BCBDDC',
  '#DADAEB',
  '#636363',
  '#969696',
  '#BDBDBD',
  '#D9D9D9',
]

export function colorScheme(data) {
  if (data.length > 20) {
    return colors
  }
  return data.length <= datavizSeries.length ? datavizSeries : tableau20
}
